import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  constructor() {}
  @Output()
  buttonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input()
  imgUrl: any = '';
  @Input()
  primaryMsg: string = '';
  @Input()
  secondaryMsg: string = '';
  @Input()
  showBtn: boolean = false;
  @Input()
  buttonText: string;
  @Input()
  emptyIcon: any;
  @Input()
  emptyTooltip: string;
  @Input()
  action: string;
  @Input()
  spacing: number = 2; //Spacing given between messages and buttons based on whether the component is error or empty state
  @Input()
  toolTip: string;
  @Input() //This variable represents the color of the message component elements. Info = "primary", error = "red"
  status: 'info' | 'error' = 'info';
  @Input()
  linkUrl: string = '';
  @Input()
  linkText: string = '';
  @Input()
  showLink: boolean = false;
  @Input()
  changeBackground: boolean = true;
  @Input()
  primaryMargin: number = 1;
  @Input()
  secondaryMargin: number = 0;
  @Input()
  cardMargin: number = 1;
  @Input()
  targetValue: string = '_self';
  @Input()
  noPaddingCard: boolean = false;
  @Input()
  setClass: string = '';
  @Input()
  secondaryMsgWidth: number;
  @Input()
  isFciPack: boolean = false;
  @Input() buttonDataAttrActionId: string;
  @Input() showImage = false;

  navigate() {
    this.buttonClick.emit(true);
  }
}
